import styled from "styled-components";
import { Link, useLocation, useRouteMatch } from "react-router-dom";
import { ReactComponent as Logo } from "../../../assets/img/Logo.svg";
import { ReactComponent as Content } from "../../../assets/img/icons/nav/cotent.svg";
import { ReactComponent as Campaign } from "../../../assets/img/icons/nav/compaign.svg";
import { ReactComponent as Cms } from "../../../assets/img/icons/nav/cms.svg";
import { ReactComponent as Audience } from "../../../assets/img/icons/nav/audience.svg";
import { ReactComponent as Analytics } from "../../../assets/img/icons/nav/analytics.svg";
import { ReactComponent as SignOut } from "../../../assets/img/icons/nav/sign_out.svg";
import { ReactComponent as Flow } from "../../../assets/img/icons/nav/Flow.svg";
import { ReactComponent as Manage } from "../../../assets/img/icons/nav/manage.svg";

import LogoutPopover from "./LogoutPopover";
import { getPlanType } from "utils";
import {
  setCampaignAndEmailsStep,
  setCampaignAudienceStep,
  setCampaignDashboardStep,
  setCampaignSmartSourceStep,
  setContentExplorerStep,
} from "modules/OnBoarding/actions";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { resetAllTabsFilter } from "modules/Analytics/utils";

const Mainnav = (props) => {
  const { path } = useRouteMatch();
  const [showAnalytics, setShowAnalytics] = useState();
  const [showAutomation, setShowAutomation] = useState(true); //  Refactor Code: Remove this line and uncomment the above
  const backOverlayForConfirm = useSelector((state) => state.uiReducer.backOverlayForConfirm);
  const backOverlayOnMainNav = useSelector((state) => state.uiReducer.backOverlayOnMainNav);
  const planType = useSelector((state) => state.user.planType);
  const isDesign = window.location.pathname.includes("design");
  // will be shown to the users who has the permission for export widget
  const exportWidgetPermission = useSelector((state) => state?.user?.userData?.export_widget_permission);

  useEffect(() => {
    const isAnalytics = window.location.pathname.includes("analytics");
    if (isAnalytics === false) {
      resetAllTabsFilter(false);
    }
  }, [window.location.pathname]);

  useEffect(() => {
    let isEnterprise = planType?.toUpperCase() === "ENTERPRISE";
    if (!planType) {
      isEnterprise = getPlanType().toUpperCase() === "ENTERPRISE";
    }
    // else {
    //   isEnterprise = ;
    // }
    setShowAnalytics(isEnterprise);
    setShowAutomation(isEnterprise);
    // if (!planType) setShowAnalytics(getPlanType().toUpperCase() === "ENTERPRISE" ? true : false);
    // else setShowAnalytics(planType === "ENTERPRISE" ? true : false);
  }, [planType]);

  // const path = useLocation().pathname; // for highlighting the sidebar icon which tab is selected
  return (
    <>
      <Wrapper className="side-nav">
        {isDesign ? (
          <ul>
            <li className="logo" data-id="menu-li-logo">
              <Link onClick={(e) => props.onExit("/campaigns", e)}>
                <Logo />
              </Link>
            </li>
            <li
              className={path.includes("/campaigns") || path.includes("publish") ? "active" : ""}
              data-id="menu-li-campaigns"
            >
              <Link onClick={(e) => props.onExit("/campaigns", e)} data-id="menu-a-campaigns">
                <Campaign />
                <span className="menu-label" data-id="menu-label-campaigns">
                  Campaigns
                </span>
              </Link>
            </li>
            <li
              className={path.includes("/design") || path.includes("/content") ? "active" : ""}
              data-id="menu-li-content"
            >
              <Link onClick={(e) => props.onExit("/content/explorer/", e)} data-id="menu-a-content">
                <Content />
                <span className="menu-label" data-id="menu-label-content">
                  Content
                </span>
              </Link>
            </li>
            <li className={path.includes("/audiences") ? "active" : ""} data-id="menu-li-audience">
              <Link onClick={(e) => props.onExit("/audiences/lists", e)} data-id="menu-a-audience">
                <Audience />
                <span className="menu-label" data-id="menu-label-audience">
                  Audience
                </span>
              </Link>
            </li>
            {showAnalytics === true && (
              <li className={path.includes("/analytics") ? "active" : ""} data-id="menu-li-analytics">
                <Link onClick={(e) => props.onExit("/analytics", e)} data-id="menu-a-analytics">
                  <Analytics />
                  <span className="menu-label" data-id="menu-label-analytics">
                    Analytics
                  </span>
                </Link>
              </li>
            )}
            {showAutomation && (
              <li className={path.includes("/automation") ? "active" : ""} data-id="menu-li-automation">
                <Link onClick={(e) => props.onExit("/automation", e)}>
                  <Flow />
                  <span className="menu-label" data-id="menu-label-automation">
                    Workflows
                  </span>
                </Link>
              </li>
            )}
            {/*
             ** Uncomment the following to include Custom Widget Groups
             */}
            {exportWidgetPermission && (
              <li
                className={`manage marginBottom ${path.includes("/groups") ? "active" : ""}`}
                data-id="menu-li-manage"
              >
                <Link onClick={(e) => props.onExit("/groups", e)}>
                  <Manage />
                  <span className="menu-label" data-id="menu-label-manage">
                    Manage
                  </span>
                </Link>
              </li>
            )}

            {/* <li className={path.includes("/cms") ? "active" : ""}>
              <Link to="#">
                <Cms />
                <span className="menu-label">CMS</span>
              </Link>
            </li> */}
            {/* <button
              onClick={() => {
                // setContentExplorerStep(0, false);
                // setCampaignAndEmailsStep(0, false);
                setCampaignDashboardStep(0, false);
                setCampaignSmartSourceStep(0, false);
                setCampaignAudienceStep(0, false);
              }}
            >
              test
            </button> */}
            <li className="sign-out" data-id="menu-li-sign-out">
              <LogoutPopover>
                <a data-id="menu-a-sign-out">
                  <span className="Workbench-nav" data-id="menu-label-sign-out">
                    Workbench
                  </span>
                  <SignOut />
                </a>
              </LogoutPopover>
            </li>
          </ul>
        ) : (
          <ul>
            <li className="logo" data-id="menu-li-logo">
              <Link
                onClick={isDesign ? (e) => props.onExit("/campaigns", e) : undefined}
                to={!isDesign ? "/campaigns" : ""}
                data-id="menu-a-sign-out"
              >
                <Logo />
              </Link>
            </li>
            <li
              className={path.includes("/campaigns") || path.includes("publish") ? "active" : ""}
              data-id="menu-li-campaigns"
            >
              <Link to="/campaigns" data-id="menu-a-campaigns">
                <Campaign />
                <span className="menu-label" data-id="menu-label-campaigns">
                  Campaigns
                </span>
              </Link>
            </li>
            <li
              className={path.includes("/design") || path.includes("/content") ? "active" : ""}
              data-id="menu-li-content"
            >
              <Link
                onClick={isDesign ? (e) => props.onExit("/content/explorer/", e) : undefined}
                to={!isDesign ? "/content/explorer/" : ""}
                data-id="menu-a-content"
              >
                <Content />
                <span className="menu-label" data-id="menu-label-content">
                  Content
                </span>
              </Link>
            </li>
            <li className={path.includes("/audiences") ? "active" : ""} data-id="menu-li-audience">
              <Link to="/audiences/lists">
                <Audience />
                <span className="menu-label" data-id="menu-label-audience">
                  Audience
                </span>
              </Link>
            </li>
            {showAnalytics === true ? (
              <li className={path.includes("/analytics") ? "active" : ""} data-id="menu-li-analytics">
                <Link to={"/analytics"}>
                  <Analytics />
                  <span className="menu-label" data-id="menu-label-analytics">
                    Analytics
                  </span>
                </Link>
              </li>
            ) : null}
            {showAutomation && (
              <li className={path.includes("/automation") ? "active" : ""} data-id="menu-li-automation">
                <Link to={"/automation"}>
                  <Flow />
                  <span className="menu-label" data-id="menu-label-automation">
                    Workflows
                  </span>
                </Link>
              </li>
            )}
            {/*
             ** Uncomment the following to include Custom Widget Groups
             */}

            {exportWidgetPermission && (
              <li
                className={`manage marginBottom ${path.includes("/groups") ? "active" : ""}`}
                data-id="menu-li-manage"
              >
                <Link to={"/groups"}>
                  <Manage />
                  <span className="menu-label" data-id="menu-label-manage">
                    Manage
                  </span>
                </Link>
              </li>
            )}

            {/* <li className="empty-li-tag"></li> */}

            {/* <li className={path.includes("/cms") ? "active" : ""}>
              <Link to="#">
                <Cms />
                <span className="menu-label">CMS</span>
              </Link>
            </li> */}
            {/* <button
              onClick={() => {
                // setContentExplorerStep(0, false);
                // setCampaignAndEmailsStep(0, false);
                setCampaignDashboardStep(0, false);
                setCampaignSmartSourceStep(0, false);
                setCampaignAudienceStep(0, false);
              }}
            >
              test
            </button> */}
            <li className="sign-out" data-id="menu-li-sign-out">
              <LogoutPopover>
                <a>
                  <span className="Workbench-nav" data-id="menu-label-sign-out">
                    Workbench
                  </span>
                  <SignOut />
                </a>
              </LogoutPopover>
            </li>
          </ul>
        )}
        {backOverlayForConfirm ? <div className="back-overlay" /> : null}
        {backOverlayOnMainNav ? <div className="back-overlay-dark" /> : null}
      </Wrapper>
    </>
  );
};

export default Mainnav;

const Wrapper = styled.div`
  background-color: #fff;
  box-sizing: border-box;
  width: 88px;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    width: 63px;
  }
  /* the following class: 'back-overlay' is for the case of Confirm box and show the greyed out overlay in the background of the Main Nav as well. */
  .marginBottom {
    //margin-bottom: 130px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-bottom: 130px;
    }
    @media all and (max-height: 890px) and (min-height: 730px) {
      margin-bottom: 220px;
    }
  }
  .back-overlay {
    height: 100vh;
    width: 100%;
    background: grey;
    opacity: 0.2;
    top: 0;
    left: 0;
  }
  .back-overlay-dark {
    height: 100vh;
    width: 89px;
    opacity: 0.6;
    top: 0;
    left: 0;
    background-color: black;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 63px;
    }
  }
  ul {
    margin: 0px;
    padding: 0;
    display: block;
    min-height: 100vh;
    position: relative;
    border-right: 1px solid #e7e7e7;
    background: rgba(255, 255, 255, 0.57);
    float: left;
    width: 89px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 63px;
    }
    li {
      display: block;
      border-radius: 8px;
      text-align: center;
      padding: 8px 0;
      margin: 25px 10px;
      transition: 0.5s;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        border-radius: 6px;
        padding: 3px 0;
        margin: 25px 7px;
      }
      @media all and (max-width: 1600px) {
        margin: 12px 7px;
      }
      /* @media all and (max-height: 810px) {
        margin: 10px;
      } */
      &.active,
      &:hover:not(.logo) {
        background: #ebf5ee;
        a {
          color: #27ce0a;
          svg path {
            fill: #27ce0a;
          }
          .menu-label {
            opacity: 1;
          }
        }
      }
      &.manage {
        &.active,
        &:hover:not(.logo) {
          svg path[stroke] {
            stroke: #27ce0a;
          }
        }
      }
      &.logo {
        margin-bottom: 45px;
        margin-top: 39px;
        svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            height: 18px;
            width: auto;
          }
        }
        /* @media all and (max-height: 810px) {
          margin-bottom: 25px;
        } */
      }
      &.sign-out {
        position: absolute;
        bottom: 0px;
        @media all and (max-width: 1600px), (max-height: 729px) {
          bottom: 20px;
        }
        left: 0;
        width: 60px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 43px;
          bottom: -12px;
        }
        &:hover {
          background: transparent;
        }
      }
      a {
        text-decoration: none;
        display: block;
        transition: 0.5s;
        .Workbench-nav {
          color: #27ce0a;
          font-size: 24px;
          font-weight: 600;
          -ms-transform: rotate(-90deg);
          transform: rotate(-90deg);
          display: block;
          margin-bottom: 25px;
          letter-spacing: -0.6px;
          font-family: "Roboto Slab", serif;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            margin-bottom: 18px;
            font-size: 17px;
          }
        }
        svg {
          transition: 0.5s;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 18px;
            height: auto;
          }
        }
        .menu-label {
          color: #424b50;
          font-weight: 800;
          font-size: 12px;
          text-align: center;
          display: block;
          transition: 0.5s;
          opacity: 0;
          letter-spacing: -0.3px;
          font-family: "Roboto", sans-serif;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 9px;
          }
        }
      }
    }
  }
`;
